import {RefCallback} from 'react';

import useResizeObserver from 'ui-library/hooks/useResizeObserver';

export function useIsSmallerThan(maxWidth: number): {
  isSmallerThan: boolean;
  ref: RefCallback<HTMLElement>;
} {
  const {ref, width} = useResizeObserver();
  const isSmallerThan = width != null && width < maxWidth;

  return {isSmallerThan, ref};
}
